import axios from "axios";

const AccessKeys = axios.create({
  baseURL: process.env.REACT_APP_ACCESS_API_ENDPOINT,
});
//Both URL should be same
export const url = process.env.REACT_APP_ACCESS_API_ENDPOINT;
 
export default AccessKeys;

